import { accordion } from './modules/accordion';
import { anchorSmoothMove } from './modules/anchorSmoothLink';
import { aosConfig } from './modules/aosConfig';
import { filterAction } from './modules/filterAction';
import { headerUiControl } from './modules/headerUiControle';
import { modalConfig } from './modules/modal/modalConfig';
import { newsTabToggle } from './modules/newsTabToggle';
import { scrollHint } from './modules/scrollHint';
import { commonSearchConfig } from './modules/searchConfig';
import { indexSlider } from './modules/swiperConfig';
import { windowAction } from './modules/windowAction';
import { sortAction } from './modules/sortAction';
import { movieConfig } from './modules/movieConfig';

headerUiControl();
accordion();
windowAction();
indexSlider();
newsTabToggle();
aosConfig();
modalConfig();
anchorSmoothMove();
scrollHint();
filterAction();
commonSearchConfig();
sortAction();
// movieConfig();
